<template>
  <Content @back="back">
    <template v-slot:nav_left>
      <div>
        <span class="navTitle " @click="jumpTo('/supervision/indexSupervisionExpert')" v-if="userRole === 'expert'">精英机构</span>
        <span class="navTitle " @click="jumpTo('/supervision/supervisionTrain')">训练督导</span>
        <span class="navTitle active">赛事督导</span>
      </div>
    </template>
    <template v-slot:nav_right>
      <div v-if="userRole === 'expert'" class="yioks_btn" @click="openAddDialog">添加赛事督导</div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <select
            v-model="selectVal.organUuid"
            class="yioks_select"
            @change="changeOrg"
          >
            <option v-if="organList.length > 1" value="">全部会员协会</option>
            <option
              v-for="item in organList"
              :key="item.organUuid"
              :value="item.organUuid"
            >
              {{ item.organShortName }}
            </option>
          </select>
          <select
            v-model="selectVal.youthUuid"
            class="yioks_select"
            @change="changeCenter"
          >
            <option v-if="centerList.length !== 1" value="">
              全部培训机构
            </option>
            <option
              v-for="item in centerList"
              :key="item.uuid"
              :value="item.uuid"
            >
              {{ item.youthShortName }}
            </option>
          </select>
        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.seacherString"
            type="text"
            class="yioks_input"
            placeholder="请输入关键词"
            @keyup.enter="changeQuery(true)"
          >
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th name"><strong>精英机构</strong></div>
              <div class="th org"><strong>比赛名称</strong></div>
              <div class="th telNumber"><strong>组别</strong></div>
              <div class="th squad"><strong>球队</strong></div>
              <div class="th idName" v-if="userRole === 'expert'"><strong>教练员</strong></div>
              <div class="th idName" v-else><strong>督察员</strong></div>
              <div class="th status"><strong>总分</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll >
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                        v-for="(item, index) in supervisionList"
                        :key="index"
                        class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td name" :title="item.youthShortName">
                      <p>{{ item.youthShortName || '--' }}</p>
                    </div>
                    <div class="td org" :title="item.matchName">
                      <p>{{item.matchName || '--'}}</p>
                    </div>
                    <div class="td telNumber" :title="item.matchGroup">
                      <p>{{ item.matchGroup || '--'}}</p>
                    </div>
                    <div class="td squad" :title="item.squadName">
                      <p>{{ item.squadName || '--'}}</p>
                    </div>
                    <div class="td idName" :title="item.trainCoach" v-if="userRole === 'expert'">
                      <p>{{ item.trainCoach || '--'}}
                        <!--<template v-if="item.trainCoach && item.otherCoach">-->
                          <!--,-->
                        <!--</template>-->
                        <!--<template v-if="item.otherCoach">-->
                          <!--{{item.otherCoach}}-->
                        <!--</template>-->
                      </p>
                    </div>
                    <div class="td idName" :title="item.trainSupervisory" v-else>
                      <p>{{ item.trainSupervisory || '--'}}</p>
                    </div>
                    <div class="td status" :title="item.totalScore">
                      <p>{{ item.totalScore || '--' }}</p>
                    </div>
                    <div class="td opt" v-if="userRole === 'expert'">
                      <p>
                        <span class="item" @click="goInfo(item.uuid)">查看</span>
                        <span class="item" @click="download(item.uuid)"  style="margin-left:5px" v-if="item.supervisorySignatoriesUuids">下载</span>
                        <span class="item" @click="goEdit(item.uuid)"  style="margin-left:5px"  v-if="!item.supervisorySignatoriesUuids">编辑</span>
                        <span class="item" @click="toDeleteItem(item)"  style="margin-left:5px"  v-if="!item.supervisorySignatoriesUuids">删除</span>
                      </p>

                    </div>
                    <div class="td opt" v-else >
                      <p>
                        <span class="item" @click="goInfo(item.uuid)">查看</span>
                        <span class="item" @click="download(item.uuid)"  style="margin-left:5px" v-if="item.supervisorySignatoriesUuids">下载</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty" />
      </div>
      <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
      <yioks-tip
        :showTip="isShowDeleteTips"
        tipMsg="确定删除该数据吗？"
        @callback="deleteBack"
      />
      <template v-if="addCenterBtn">
        <AddPlayerDialog :addCenter.sync="addCenterBtn" :centerUuid="centerUuid" :organList="organList" :isEdit="isEdit" @hideDialog="hideDialog"></AddPlayerDialog>
      </template>
      <el-dialog
        :visible.sync="batchAdd"
        width="500px"
        title="选择单位/组别"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        custom-class="yioks_alert2"
      >
        <el-form ref="batchInfo" :model="batchInfo" label-width="120px">
          <vue-scroll ref="scroll" :ops="ops">
            <div style="margin-right: 30px">
                <el-form-item
                  label="管理协会"
                  required
                  prop="organUuid"
                  :rules="[{ required: true, message: '必填项' }]"
                >
                  <el-select
                    v-model.trim="batchInfo.organUuid"
                    style="width: 100%"
                    placeholder="请选择管理协会"
                    @change="changeBathOrg"
                  >
                    <el-option
                      v-for="(item, index) in batchOrganList"
                      :key="index"
                      :value="item.organUuid"
                      :label="item.organShortName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="单位"
                  required
                  prop="youthUuid"
                  :rules="[{ required: true, message: '必填项' }]"
                >
                  <el-select
                    v-model.trim="batchInfo.youthUuid"
                    style="width: 100%"
                    placeholder="请选择管理协会后再选择单位"
                    @change="changeBathCenter"
                  >
                    <el-option
                      v-for="item in batchCenterList"
                      :key="item.uuid"
                      :value="item.uuid"
                      :label="item.youthShortName"
                    ></el-option>
                  </el-select>
                </el-form-item>
            </div>
          </vue-scroll>
        </el-form>
        <div class="btn-wrapper" style="display:flex;justify-content:center">
          <el-button type="primary" @click="toAddSupervision">添加赛事督导</el-button>
        </div>
      </el-dialog>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/regular/edit'
import supervision from '@/api/supervision'
import center from '@/api/center'
import squad from '@/api/squad'
import storage from '@/utils/storage'
import person from '@/assets/images/common/person.jpg'
import regions from '@/utils/regions'
import { centerStatus } from '@/utils/yioks_filter'
import mixinAddressForSH from '@/mixin/mixinAddressForSH';
import mixinAppConfig from "@/mixin/mixinAppConfig";
import {ops} from "@/utils/scrollIndialog";
import common from '@/api/common'
export default {
  mixins: [mixinAddressForSH,mixinAppConfig],
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'AddPlayerDialog': () => import('@/components/center'),
  },
  filters: {
    statusFilter (val) {
      return centerStatus(val)
    }
  },
  data () {
    return {
      ops,
      regions,
      centerUuid: '',
      selectRegions: regions,
      selectCityList: [],
      coach: '',
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      person,
      addCenterBtn: false,
      loading: true,
      coachUuid: '',
      addbtnLoading: false,
      isShowDeleteTips: false,
      deleteUuid: '',
      batchAdd: false,
      isEdit: false,
      downIng: false,
      selectVal: {
        seacherString: '',
        youthUuid: "",
        organUuid: ''
      },
      organList: [], // 机构列表
      centerList: [], // 青训中心列表,
      supervisionList: [], // 青训中心列表,
      squadList: [],
      selectsquadList: [],
      cityList: [],
      batchOrganList: [], // 管理协会列表
      batchCenterList: [], // 单位列表
      batchSquadList: [], //  球队列表
      userRole:'',
      batchInfo: {
        organUuid: "", // 协会
        organShortName: "",
        youthUuid: "", // 机构
        youthShortName: "",
      }, // 弹窗表单
    }
  },
  watch: {
    page () {
      this.changeQuery()
    },
  },
  created () {
    const { page, squadUuid, youthUuid, organUuid, seacherString } = this.$route.query
    page && (this.page = Number(page))
    squadUuid && (this.$set(this.selectVal, 'squadUuid', squadUuid))
    youthUuid && (this.$set(this.selectVal, 'youthUuid', youthUuid))
    organUuid && (this.$set(this.selectVal, 'organUuid', organUuid))
    seacherString && (this.$set(this.selectVal, 'seacherString', seacherString))
    // this.getCoachAccount()
    this.getOrganListAndCenterList();
//     this.getCenterList()
    this.changeQuery();
  },
  methods: {
    download (uuid) {
      if (this.downIng) return
      this.downIng = true
      supervision.supervisoryMatchDownLoadPdf({ dataUuid: uuid }).then(res => {
        const { fileName, filePath } = res
        const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
        common.downfile(transferPath, fileName);
        this.downIng = false
      }).catch(err => {
        this.downIng = false
      })
    },
    back(){
      if ( this.userRole === "admin"){
        this.$router.push('/home/index?details=mans')
      }else {
        this.$router.push('/home')
      }
    },
    jumpTo(path) {
      this.$router.replace(path)
    },
    /* 添加球探 == 球员弹窗 */
    openAddDialog() {
      this.batchAdd = true;
    },
    /* 机构选择 */
    changeBathOrg(val) {
      this.batchSquadList = [];
      this.batchCenterList = [];
      this.$set(this.batchInfo, "youthUuid", "");
      this.$set(this.batchInfo, "organShortName", "");
      this.$set(this.batchInfo, "youthShortName", "");
      this.$set(this.batchInfo, "squadUuid", "");
      if (this.batchInfo.organUuid) {
        this.batchInfo.organShortName = this.batchOrganList.find((item) => {
          return item.organUuid === this.batchInfo.organUuid;
        }).organShortName;
        this.batchCenterList =
          this.batchOrganList.find((item) => {
            return item.organUuid === this.batchInfo.organUuid;
          }).youthList || [];
        if (this.batchCenterList.length === 1) {
          // this.$set(this.selectVal, 'youthUuid', this.centerList[0].uuid)
          this.$set(this.batchInfo, "youthUuid", this.batchCenterList[0].uuid);
          this.$set(
            this.batchInfo,
            "youthShortName",
            this.batchCenterList[0].youthShortName
          );
          this.batchSquadList =
            this.batchCenterList.find((item) => {
              return item.uuid === this.batchInfo.youthUuid;
            }).squadList || [];
          if (this.batchSquadList.length === 1) {
            this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
          }
        }
      }
    },

    /* 单位变化 */
    changeBathCenter(val) {
      this.batchInfo.squadUuid = "";
      this.batchSquadList = [];
      this.batchInfo.youthShortName = "";
      if (this.batchInfo.youthUuid) {
        this.batchInfo.youthShortName =
          this.batchCenterList.find((item) => {
            return item.uuid === this.batchInfo.youthUuid;
          }).youthShortName || "";
        this.batchSquadList =
          this.batchCenterList.find((item) => {
            return item.uuid === this.batchInfo.youthUuid;
          }).squadList || [];
        // if (this.batchSquadList.length === 1) {
        //   this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
        // }
      }
    },
    // 获取协会列表
    getOrganListAndCenterList() {
      let data = this.uuid;
      squad.getOrgListBySystem(data).then((res) => {
        this.batchOrganList = res;
        this.organList = res;
        if (this.selectVal.organUuid) {
          if (this.selectVal.youthUuid) {
            this.centerList =
              this.organList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            if (this.selectVal.squadUuid) {
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
            }
          }
        } else {
          if (this.organList.length === 1) {
            this.$set(this.selectVal, "organUuid", this.organList[0].organUuid);
            this.$set(
              this.batchInfo,
              "organUuid",
              this.batchOrganList[0].organUuid
            );
            this.$set(
              this.batchInfo,
              "organShortName",
              this.batchOrganList[0].organShortName
            );
            this.centerList =
              this.batchOrganList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            this.batchCenterList = this.centerList;
            if (this.centerList.length === 1) {
              this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
              this.$set(
                this.batchInfo,
                "youthUuid",
                this.batchCenterList[0].uuid
              );
              this.$set(
                this.batchInfo,
                "youthShortName",
                this.batchCenterList[0].youthShortName
              );
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
              this.batchSquadList = this.squadList;
              if (this.squadList.length === 1) {
                this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
                this.$set(this.batchInfo, "squadUuid", this.squadList[0].uuid);
                this.changeTeam(this.squadList[0].uuid);
              }
            }
          }
        }
      });
    },
    getCenterList () {
      this.loading = true
      this.empty = false
      this.showList = false
      let req = supervision.getSupervisoryMatchListByExpert
      const userRole = storage.get('userInfo').userRole
      this.userRole = userRole;
      if (userRole === 'system' || userRole === 'admin') { req = supervision.getSupervisoryMatchListBySystem }
      req({ page: this.page, size: this.pageSize, seacherString: this.selectVal.seacherString, squadUuid: this.selectVal.squadUuid, youthUuid: this.selectVal.youthUuid, organUuid: this.selectVal.organUuid, }).then((res) => {
        this.loading = false
        let data = res.content
        this.total = res.totalElements
        if (data.length) {
          this.supervisionList = data
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch((err) => {
        this.loading = false
        console.error(err)
      })
    },
    editCenter (uuid) {
      this.isEdit = true
      this.centerUuid = uuid
      this.addCenterBtn = true
    },
    goInfo (uuid) {
      this.$router.push({
        path: 'supervisionMatchView',
        query: {
          supervisionUuid:uuid
        }
      })
    },
    goEdit (uuid) {
      this.$router.push({
        path: 'supervisionMatchEdit',
        query: {
          supervisionUuid:uuid
        }
      })
    },
    changeSquadUuid(val) {
      this.changeQuery(true);
    },

    changeOrg(val) {
      this.centerList = [];
      this.squadList = [];
      this.$set(this.selectVal, "youthUuid", "");
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.organUuid) {
        const { youthList } = this.organList.find((item) => {
          return item.organUuid === this.selectVal.organUuid;
        });
        this.centerList = youthList || [];
        if (this.centerList.length === 1) {
          this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
          this.squadList =
            this.centerList.find((item) => {
              return item.uuid === this.selectVal.youthUuid;
            }).squadList || [];
          if (this.squadList.length === 1) {
            this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
          }
        }
      }
      this.changeQuery(true);
    },

    changeCenter(val) {
      this.squadList = [];
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.youthUuid) {
        this.squadList =
          this.centerList.find((item) => {
            return item.uuid === this.selectVal.youthUuid;
          }).squadList || [];
        if (this.squadList.length === 1) {
          this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
        }
      }
      this.changeQuery(true);
    },


    changeQuery (flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          squadUuid: this.selectVal.squadUuid,
          youthUuid: this.selectVal.youthUuid,
          seacherString: this.selectVal.seacherString,
          organUuid: this.selectVal.organUuid
        }
      })
      this.getCenterList()
    },
    hideDialog (val) {
      this.addCenterBtn = val
      this.getCenterList()
    },
    // 添加督导训练
    toAddSupervision() {
      this.$refs.batchInfo.validate((valid) => {
        if(valid){
          let { organUuid,  youthUuid } = this.batchInfo;
          let queryData = {
            organUuid,
            youthUuid,
          };
          this.$router.push({
            path: "supervisionMatchAdd",
            query: queryData,
          });
        }
      })
    },
    /* 删除球探报告 */
    toDeleteItem(row) {
      const { uuid } = row;
      this.deleteUuid = uuid;
      this.isShowDeleteTips = true;
    },

    deleteBack(sure) {
      if (sure) {
        supervision
        .deleteMatchSupervisory(this.deleteUuid).then((res) => {
          this.changeQuery(true);
          this.isShowDeleteTips = false;
        })
        .catch((err) => {
          console.error(err);
          this.isShowDeleteTips = false;
        });
      } else {
        this.isShowDeleteTips = false;
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .navTitle
    padding 10px 20px
    /*margin-right .2rem*/
    cursor pointer
    &:last-child
    &:last-child
      margin-right 0
    &.active
      background $green_color
      color #FFF
  .list_wrap
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 425px;
        padding-bottom:15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .seq{
        width 7%
      }
      .name{
        width 14%
      }
      .org{
        width: 16%;
      }
      .telNumber{
        width:15%;
      }
      .squad{
        width:13%;
      }
      .status{
        width 7%
      }
      .idName{
        width: 13%;
      }
      .opt{
        width: 15%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
    }
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
</style>


